// Android: si la PWA ya está instalada, abrirla en vez de seguir en Chrome. Solo actúa con partners/staff:
// getInstalledRelatedApps devuelve [] cuando la página no enlaza el manifest (gate del layout). Ver _docs/frontend/pwa.md
const INTENT_TRIED = "pwaIntentTried"

// Un intento por pestaña: si Android devuelve el intent a Chrome (acceso directo sin WebAPK, o Chrome fijado como
// predeterminado) la página vuelve a cargar y, sin esta marca, repetía sin fin. Sin sessionStorage no se intenta.
function intentTried() {
  try { return sessionStorage.getItem(INTENT_TRIED) === "1" } catch { return true }
}

function markIntentTried() {
  try { sessionStorage.setItem(INTENT_TRIED, "1") } catch { /* sin storage: ya se trató como intentado */ }
}

document.addEventListener("turbo:load", () => {
  // El manifest se sirve same-origin (request.base_url), así que el hostname
  // actual matchea la URL de la PWA instalada en cualquier dominio (gfoods.io,
  // gfood.io, ngrok) sin listarlos.
  const manifestUrlBase = window.location.hostname;
  const userAgent = navigator.userAgent.toLowerCase();
  const isInStandaloneMode = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;

  if (isInStandaloneMode) return

  if (/android/.test(userAgent) && !isInStandaloneMode) {
    if ('getInstalledRelatedApps' in navigator) {
      navigator.getInstalledRelatedApps().then((apps) => {
        const isInstalled = apps.some(app =>
          app.platform === 'webapp' &&
          app.url.includes(manifestUrlBase)
        );

        if (isInstalled && !intentTried()) {
          markIntentTried();
          const currentUrl = window.location.href.replace(/^https?:\/\//, "");
          const intentUrl = `intent://${currentUrl}#Intent;scheme=https;end`;
          window.location.href = intentUrl;
        } else if (!isInstalled) {
          console.log("PWA no instalada. Mostrar instrucciones o botón");
        }
      });
    } else {
      console.log("getInstalledRelatedApps no está disponible en este navegador");
    }
  } else {
    // console.log("No es un dispositivo Android.");
  }
});
